import TomSelectBaseController from "./tom_select_base";

export default class extends TomSelectBaseController {
  get tomSelectOptions() {
    return {
      create: true,
      sortField: [{ field: "$order" }, { field: "$score" }],
    };
  }
}
